// @ts-nocheck
import React from 'react'
import Spinner from '../components/LoadingLogo'
import { ErrorBoundary } from './try-render'
import { observer } from 'mobx-react'
const cache = new WeakMap()

function render (loaded) {
  let Component = loaded.default || loaded
  const isObserver = Component.isMobXReactObserver || Object.getOwnPropertySymbols(Component).find(s => String(s) === 'Symbol(isMobXReactObserver)')
  if (!cache.has(Component)) {
    cache.set(Component, isObserver ? Component : observer(Component))
  }
  Component = cache.get(Component)
  const Dynamic = ({ getRef, ...props }) => {
    if (Component.displayName?.includes('withRouter(')) props.wrappedComponentRef = getRef
    else props.ref = getRef

    return (
      <ErrorBoundary>
        <Component {...props} />
      </ErrorBoundary>
    )
  }
  return Dynamic
}

// NOTE: Conceptually this is a transparent component loader so we set the type
//       that way for convenience everywhere else. This is, of course, a lie and
//       TS doesn't like it so type checking is disabled for the file. 
type ImportThunk<T> = () => Promise<{default: T}>
function Dynamic<P extends React.ComponentType<any>>(cmp?: P | ImportThunk<P> | Promise<ImportThunk<P>>, opts = { ssr: false }): P {
  if (!cmp) return () => null
  if (cmp.displayName || cmp.propTypes || cmp.__docgenInfo || (cmp.prototype && cmp.prototype.render)) {
    return render(cmp)
  }
  
  return props => {
    const [Loaded, setLoaded] = React.useState(null)
    React.useEffect(async () => {
      let comp
      if (cmp instanceof Function) { // import factory fn
        comp = await cmp()
      } else { // getComponent
        comp = await (await cmp)()
      }
      comp = comp?.default || comp
      if(!comp) {
        console.error('component not found', cmp, props)
        return
      }
      setLoaded(() => {
        if (comp.displayName || comp.propTypes || comp.__docgenInfo || (comp.prototype && comp.prototype.render)) {
          return render(comp)
        } else {
          return comp
        }
      })
    }, [])
    if(!Loaded && props.cmpId && typeof window !== 'undefined') {
      const el = document.getElementById('iar_' + props.cmpId)
      const html = el?.innerHTML || ''
      return <div suppressHydrationWarning dangerouslySetInnerHTML={{__html: html }} />
    }
    return Loaded && <Loaded {...props} />
  }
}

export default Dynamic

export function importModule(url: string, id: string, opts: object = {}) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.type = 'module'
    script.crossOrigin = 'use-credentials'
    //    script.textContent = `import * as m from "${url}"; window['${id}'] = m;`;
    script.src = url
    script.onload = () => {
      resolve(window[id])
      //      delete window[id]
      //      script.remove();
    }

    script.onerror = () => {
      reject(new Error('Failed to load module script with URL ' + url))
      delete window[id]
      //      script.remove();
    }
    Object.assign(script, opts)

    document.documentElement.appendChild(script)
  })
}
